import { render, staticRenderFns } from "./ChoiceCandidat.vue?vue&type=template&id=719a72d0&scoped=true"
import script from "./ChoiceCandidat.vue?vue&type=script&lang=js"
export * from "./ChoiceCandidat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719a72d0",
  null
  
)

export default component.exports